import { useFlags } from 'launchdarkly-react-client-sdk';

import { useNoteFormContext } from '../../context/noteFormContext';
import TranscriptComponent from '../../transcript/transcript';

export const Transcript = () => {
  const { note } = useNoteFormContext();
  const { aiScribe: enableAiScribe } = useFlags();

  if (!enableAiScribe || !note?.aiScribe?.transcript) return null;

  return <TranscriptComponent note={note} />;
};
